import DEFAULT_PHOTO_PROFILE from "@/assets/images/default-avatar.png";
import FILE from "@/assets/images/ui/file.png";
import WHITE_QOALA_LOGO from "@/assets/images/ui/logo-white.png";

import LOGOUT from "@/assets/images/ui/logout.png";
import FALCON_LOGO_BACKGROUND_BLACK from "@/assets/images/ui/falcon-edge-icon-black-logo.png";
import QOALA_LOGO from "@/assets/images/ui/qoala-logo.png";
import QOALA_THINK_ICON from "@/assets/images/ui/qoala-think.gif";
import FALCON_EDGE_FULL_BLACK from "@/assets/images/ui/FalconEdgeFull-Black.png"
import FALCON_EDGE_FULL_WHITE from "@/assets/images/ui/FalconEdgeFull-White.png"

export {
  QOALA_LOGO,
  WHITE_QOALA_LOGO,
  FALCON_LOGO_BACKGROUND_BLACK,
  DEFAULT_PHOTO_PROFILE,
  FILE,
  LOGOUT,
  QOALA_THINK_ICON,
  FALCON_EDGE_FULL_BLACK,
  FALCON_EDGE_FULL_WHITE
};
